<div class="blog-top">
  <div class="container top-title">
  <div class="title">İletişim</div>
  <div class="b-title">
    <div class="slogan">VizeAsist {{ contact?.title }}</div>
   
  </div>
</div></div>

<div class="container">
  
<div *ngIf="contact" class="container">


  <div class="row">

    <section class="space">
      <div class="container">
        <div class="row gy-30 justify-content-center">
          <div class="col-md-4 col-lg-4">
            <div class="contact-box">
              <div class="contact-box_icon">
                <i class="fa fa-location-dot"></i>
              </div>
              <div class="contact-box_info">
                <h4 class="contact-box_title">Adres</h4>
                <p class="contact-box_text">{{ contact?.address }}</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="contact-box">
              <div class="contact-box_icon">
                <i class="fa fa-phone"></i>
              </div>
              <div class="contact-box_info">
                <h4 class="contact-box_title">İletişim</h4>
                <a [href]="'mailto:'+ contact.email" class="contact-box_link" target="_blank">{{ contact?.email }}</a>
                <a *ngIf="contact?.phone != ''" [href]="'tel:' + contact.phone" class="contact-box_link">T: {{ contact?.phone }}</a>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="contact-box">
              <div class="contact-box_icon">
                <i class="fa fa-clock"></i>
              </div>
              <div class="contact-box_info">
                <h4 class="contact-box_title">Kurumsal Bilgiler</h4>
                <p class="contact-box_text">Vergi No: {{ contact?.taxNumber }}</p>
                <p class="contact-box_text">Mersis No: {{ contact?.mernisNo }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</div>
</div>

<div *ngIf="contact?.locationLink?.includes('iframe')" class="responsive-iframe"><iframe [(src)]="locationLink" style="border:0;" allowfullscreen="" loading="lazy"
  referrerpolicy="no-referrer-when-downgrade"></iframe></div>